import React from "react";
import { AlertTriangle, CheckCircle2, CircleHelp } from "lucide-react";

const TONE_META = {
  neutral: {
    icon: CircleHelp,
    className: "border-slate-200 bg-slate-50 text-slate-700",
  },
  warning: {
    icon: AlertTriangle,
    className: "border-amber-200 bg-amber-50 text-amber-800",
  },
  danger: {
    icon: AlertTriangle,
    className: "border-rose-200 bg-rose-50 text-rose-800",
  },
};

export default function CalculatieValidationPanel({ items }) {
  return (
    <section className="border border-slate-200 bg-white">
      <div className="border-b border-slate-200 px-4 py-3">
        <h3 className="text-sm font-semibold text-slate-900">Controlepunten</h3>
        <p className="mt-1 text-sm text-slate-600">Snelle frontendcontrole voor overdracht, marge en projectimpact.</p>
      </div>

      <div className="space-y-2 px-4 py-4">
        {items.length > 0 ? (
          items.map((item, index) => {
            const meta = TONE_META[item.tone] || TONE_META.neutral;
            const Icon = meta.icon;
            return (
              <div key={`${item.label}-${index}`} className={`rounded-sm border p-3 text-sm ${meta.className}`}>
                <div className="flex items-start gap-2">
                  <Icon size={16} className="mt-0.5 shrink-0" />
                  <div>
                    <p className="font-medium">{item.label}</p>
                    {item.detail ? <p className="mt-1 text-xs opacity-90">{item.detail}</p> : null}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="flex items-start gap-2 rounded-sm border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-800">
            <CheckCircle2 size={16} className="mt-0.5 shrink-0" />
            <div>
              <p className="font-medium">Geen directe controlesignalen</p>
              <p className="mt-1 text-xs">De huidige calculatie oogt compleet op basis van frontendregels.</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
